import { render } from "./DownloadlistViewlist.vue?vue&type=template&id=5d57bcc8&scoped=true"
import script from "./DownloadlistViewlist.vue?vue&type=script&lang=js"
export * from "./DownloadlistViewlist.vue?vue&type=script&lang=js"

import "./DownloadlistViewlist.vue?vue&type=style&index=0&id=5d57bcc8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d57bcc8"]])

export default __exports__